import React  from 'react'; // need this to use jsx (the html inside the array. noramally that would be in a string)
const value = {
  path:"land_transfer_rebate",
  title:"Land Transfer Tax Rebate",
  date_modified:"Aug 2020",
  date_created:"Aug 2020",
  content:
[
<p align="justify">
First-time homebuyers in Ontario, B.C., and P. E. I. are eligible to receive a refund on all, or some, of the land transfer tax owed. For example, in Ontario, if a first-time home buyer:
</p>
,
<ol>
  <li>is a Canadian citizen or permanent resident</li>
  <li>has not owned a home before, anywhere in the world</li>
  <li>is 18 years or older</li>
  <li>is going to live in the home within 9 months of purchasing it</li>
  <li>does not have a spouse who owned a house while being their spouse</li>
</ol>
,
<p align="justify">
then they can receive a rebate of up to $4,000 on their land transfer tax, depending on the price of the house. If only one spouse qualifies, the first-time buyer can still qualify for up to half of the rebate. In Toronto, first-time buyers can also qualify for an additional municipal rebate of up to $4,475.
</p>
,
<p align="justify">
Your real estate lawyer can apply for the rebate on your behalf. Tell your lawyer you want to apply, and if all the requirements are met, the rebate amount should be deducted from the amount of land transfer tax owed, at closing.
</p>
,
<p align="justify">
B.C. and P. E. I. have similar programs. First-time buyers in B. C. can qualify for a rebate of up to $8,000, and residents of P. E. I. up to $2,000. Both locales have different, but similar, qualifying conditions. If you want to apply for the land transfer tax rebate, you can ask your real estate lawyer to help you with the process.
</p>
],
  tags:["government program"]
}

export default value



// WEBPACK FOOTER //
// src/content/landTransferRebate.js